import { apiUtils } from '../utils/apiUtils'

export default {
  getInscriptionContacts: function (magasinPageId) {
    return fetch(`${apiUtils.notion}/contact/inscription?magasinPageId=${magasinPageId}&force=true`)
      .then((res) => {
        if (res.ok) {
          return res.json().then((body) => body.contacts || [])
        }
        return []
      })
      .catch(() => [])
  },
  getEnrollContacts: function (code) {
    return fetch(`${apiUtils.client}/${code}/contacts`)
      .then((res) => (res.ok ? res.json() : []))
      .then((contacts) => (Array.isArray(contacts) ? contacts : []))
      .catch(() => [])
  },
}
